<template>
    <div>
        <Title title="专家详情" :path="formPath"/>

        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>

<!--            <div class="allexpert">-->
<!--                <swiper :options="swiperOption" ref="exswiper">-->
<!--                    <swiper-slide v-for="(c,i) in allexperts" :key="i" class="item">-->
<!--&lt;!&ndash;                        <router-link :to="'/expert/'+c.ename" :class="c.ename===name?'curr':''">&ndash;&gt;-->
<!--                        <a :class="c.ename===name?'curr':''" @click="changeZj(i)">-->
<!--                            <img :src="c.portrait"/>-->
<!--                            <div class="name">{{ c.name }}</div>-->
<!--                            <div class="yname">{{ c.yname }}</div>-->
<!--&lt;!&ndash;                        </router-link>&ndash;&gt;-->
<!--                        </a>-->
<!--                    </swiper-slide>-->
<!--                </swiper>-->
<!--                <div class="swiper-button swiper-button-next" slot="nextButton"></div>-->
<!--                <div class="swiper-button swiper-button-prev" slot="button-prev"></div>-->
<!--            </div>-->

            <div class="expert_view">
                <div class="expert_info">
                    <div class="img"><img :src="expert.portrait"/></div>
                    <div class="con">
                        <div class="name">{{ expert.name }}<span>{{ expert.yname }}</span></div>
                        <div class="desc">{{ expert.desc }}</div>
                    </div>
                </div>
                <div class="expert_rate" v-if="expert.rate" ref="line">
                    <div class="title">专家胜率
                        <div class="fte">
                        <span @click="getRate(1)" :class="expert_rate_sel===1?'curr':''">按天</span>
                        <span @click="getRate(2)" :class="expert_rate_sel===2?'curr':''">按场</span>
                        <span @click="getRate(3)" :class="expert_rate_sel===3?'curr':''">按月</span>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(c,i) in expert.rate" :key="i">
                            <div class="info">
                                <span class="name">{{ c.name }}</span>
                                <span class="sf"><i class="s">{{ c.sheng }}</i>赢<em>/</em><i class="p">{{ c.ping }}</i>和<em>/</em><i class="f">{{ c.fu }}</i>输</span>
                                <span class="sl"><i>{{ c.sl }}</i>%</span>
                            </div>
                            <div class="line"><div class="slline" :style="c.width"></div></div>

                        </li>
                    </ul>
                </div>
            </div>

<!--            <div class="tabtitle">{{ expert.name }}的预测</div>-->
            <van-list v-model="isLoading"
                      finished-text="没有了~"
                      :immediate-check="false"
                      :finished="isFinished"
                      :error.sync="isError"
                      :error-text="match.list.length>0?'读取失败':''"
                      @load="onLoadMore">
                <match_mini :data="match"/>
            </van-list>
        </template>
    </div>
</template>

<script>
    import match_mini from './public/match_mini'
    import Title from './public/title'

    export default {
        name: "expert_view",
        components: {
            match_mini,
            Title
        },
        data() {
            return {
                name: '',
                allexperts: [],
                formPath: '',
                expert: null,
                expert_rate_sel: 1,
                match: {'type': 3, 'list': []},
                ball: 1,
                page: 1,
                swiperOption: {
                    slidesPerView: 8,
                    spaceBetween: 6,
                    slidesPerGroup: 8,
                    // autoplay: {
                    //     delay: 5000,
                    //     disableOnInteraction: false
                    // },
                    loop: true,
                    navigation: {
                        nextEl: '.allexpert .swiper-button-next',
                        prevEl: '.allexpert .swiper-button-prev'
                    }
                },

                isInit: true,
                isLoading: false,
                isLoadingError: false,
                isFinished: false,
                isError: false,
            }
        },
        activated() {
            let that = this
            this.isInit = true
            this.page = 1
            this.match.list = []
            this.name = that.$route.params.name
            that.getdata()
        },
        methods: {
            onLoadMore(){
                // console.log(2)
                let that = this
                if(!that.isLoadingError)
                    that.page++
                that.getdata()
            },
            getdata(){
                let that = this
                that.$get(that.$api.expert_info, {ball: that.ball, page: that.page, name: that.name})
                    .then(function (res) {
                        // console.log(res)
                        if(res.code === 1) {
                            // that.match.total = res.data.total
                            // that.match.size = res.data.size
                            that.expert = res.data.expert
                            that.allexperts = res.data.allexperts
                            // that.$backTop()

                            let tmplist = res.data.list
                            if(tmplist.length > 0) {
                                tmplist.forEach(function (c) {
                                    c.same_num = 0
                                })
                                that.match.list = that.match.list.concat(tmplist)
                            }
                            else{
                                that.isFinished = true
                            }
                            that.isInit = false
                            that.setlinewidth()
                        }
                        else{
                            that.isError = true
                        }
                    })
                    .catch(function () {
                        that.isError = true
                        that.isLoadingError = true
                    })
                    .finally(function () {
                        that.isLoading = false
                    })
            },
            getRate(t){
                let that = this
                that.expert_rate_sel = t
                that.$get(that.$api.expert_rate, {eid: that.name, type: t})
                    .then(function (res) {
                        if(res.code === 1) {
                            that.expert.rate = res.data.rate
                            that.setlinewidth()
                        }
                    })
            },
            setlinewidth(){
                /**
                 * 设置胜率进度条长度
                 * @type {default.methods}
                 */
                let that = this
                setTimeout(function () {
                that.$nextTick(() => {
                    let line = that.$refs.line
                    if(line) {
                        let width = line.offsetWidth
                        //更新胜率滚动条长度
                        let list = that.expert.rate
                        list.forEach(function (i) {
                            let w = parseInt(i.sl / 100 * width)
                            if (i.sl < 60)
                                i.width = 'width:' + w + 'px;background-color:#ff6600;'
                            else
                                i.width = 'width:' + w + 'px'
                        })
                    }
                })
                }, 1)
            },
            changeZj(i){
                let that = this
                let name = that.allexperts[i].ename
                that.name = name
                that.page = 1
                that.expert_rate_sel = 1
                that.$toast.loading({message: '请稍后...', duration: 0, forbidClick: true})
                that.getdata()
            },
        },
        computed: {
            swiper(){
                return this.$refs.exswiper.swiper
            }
        },
        mounted() {
            // this.setlinewidth()
        },
        watch: {
            // '$route': {
            //     handler: function () {
            //         // this.match.list = []
            //         // this.$toast.loading({message: '请稍后...', duration: 0})
            //         this.getdata()
            //     }
            // }
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path === '/' ?'/expert':''

            })
        }
    }
</script>

<style scoped>

</style>
